import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OrganizationMembersModalComponent } from '../../../organizations/components/organization-members-modal/organization-members-modal.component';
import { ImageService } from '../../../services/shared/image.service';
import { OrganizationCardResponse } from '../../models/organization-card-response.model';
@Component({
    selector: 'app-directory-organization-profile-card',
    templateUrl: './organization-directory-profile-card.component.html',
    styleUrls: ['./organization-directory-profile-card.component.scss'],
})
export class OrganizationDirectoryProfileCardComponent {
    @Input() organization: OrganizationCardResponse;
    @Input() isAdminProfile: boolean;
    @Input() isActive = false;
    @Output() cardClick = new EventEmitter<string>();

    @ViewChild('membersModal') membersModal: OrganizationMembersModalComponent;

    public activeCardOrganizationId: string | null = null;

    constructor(public imageService: ImageService, public translateService: TranslateService) {}
    toggleActive(organizationId: string): void {
        this.cardClick.emit(organizationId);
    }
    getCollaboratorsText(count: number): string {
        if (count === 0) {
            return this.translateService.instant('directory.pages.organizations.collaborators.zero');
        } else if (count === 1) {
            return this.translateService.instant('directory.pages.organizations.collaborators.one');
        } else {
            return this.translateService.instant('directory.pages.organizations.collaborators.other', { count: count });
        }
    }

    openMembersModal(event: Event): void {
        event.stopPropagation();
        event.preventDefault();

        if (this.membersModal) {
            this.membersModal.showDialog();
        }
    }
}
